<template>
  <div class="flex-table-row d-flex align-items-center draw-table-row">
    <div class="draw-column column c-winner-name">
      <span class="winner-number">{{ this.winner.position }}</span>
      of {{this.winnerCount}}
    </div>
    <div
      class="draw-column column c-first-name"
    >{{this.winner.selectedAttendee.firstname ? this.winner.selectedAttendee.firstname: '-' }}</div>
    <div
      class="draw-column column c-last-name"
    >{{this.winner.selectedAttendee.lastname ? this.winner.selectedAttendee.lastname : '-'}}</div>
    <div
      class="draw-column column c-email"
    >{{this.winner.selectedAttendee.email ? this.winner.selectedAttendee.email : '-'}}</div>
    <div
      class="draw-column column c-attendee"
      :class="{empty_attendees:!this.winner.selectedAttendee.attendee_no }"
    >
      <a
        v-if="this.winner.selectedAttendee.attendee_no"
        v-bind:href="this.attendeeLink"
        target="_blank"
      >{{this.winner.selectedAttendee.attendee_no ? this.winner.selectedAttendee.attendee_no : "-"}}</a>
      <template v-else>-</template>
    </div>
    <div
      class="draw-column column c-ticket"
    >{{this.winner.selectedAttendee.ticket_no ? this.winner.selectedAttendee.ticket_no : '-'}}</div>
    <div class="draw-column column c-draw-status">
      <div v-if="this.winner.status==='accept'" class="alert alert-success">confirmed</div>
      <div
        v-if="this.winner.status==='respin' || this.winner.status==='move'"
        class="alert alert-reject"
        role="alert"
      >rejected</div>
      <div
        v-if="this.winner.status==='skip' && 
         this.nonReSpinnable.indexOf(this.winner.position) < 0 &&
         !this.drawn"
        class="skip-container"
      >
        <div class="alert alert-skip" role="alert">skipped</div>
        <button class="skip" @click="reDraw()">
          <img src="../assets/images/skipped.svg" alt="skipped button">
        </button>
      </div>
      <div
        v-if="this.winner.status==='skip' && (this.drawn || this.nonReSpinnable.indexOf(this.winner.position)>= 0)"
        class="alert alert-skipped"
      >skipped</div>
    </div>
    <div class="draw-column column type-date c-time">
      {{ formatDate(this.winner.createdAt) }}
      <span>{{ formatTime(this.winner.createdAt) }}</span>
    </div>
    <div
      class="draw-column column c-reject"
      :title="this.winner.reason"
    >{{this.winner.reason ? this.winner.reason : "-"}}</div>
  </div>
</template>

<script>
import moment from "moment";
import config from "@/config/config";
export default {
  name: "DrawTableRow",
  props: [
    "winner",
    "winnerCount",
    "prizeId",
    "prizeName",
    "nonReSpinnable",
    "drawn"
  ],
  computed: {
    attendeeLink() {
      return (
        config.gevmeUrl +
        localStorage.getItem("org_id") +
        "/events/" +
        localStorage.getItem("event_id") +
        "/registration/attendees#/a/" +
        this.winner.selectedAttendee._id +
        "/t/submitted-data"
      );
    }
  },
  methods: {
    formatDate(date) {
      return moment(date).format("MMM Do 'YY");
    },
    formatTime(time) {
      return moment(time).format("h:mm A");
    },
    reDraw() {
      this.$router.push({
        name: "PerformDraw",
        params: {
          reSpinData: {
            prizeId: this.prizeId,
            drawIdOfPosition: this.winner.id,
            position: this.winner.position
          },
          prizeInfo: {
            id: this.prizeId,
            winnerCount: this.winnerCount,
            name: this.prizeName
          }
        }
      });
    }
  }
};
</script>

<style scoped>
.draw-table-row {
  font-size: 14px;
  color: #262626;
}
/* .draw-column {
  justify-content: center;
} */
.c-winner-name {
  min-width: 80px;
  font-size: 8px;
}

.c-winner-name > .winner-number {
  font-size: 20px;
  font-weight: bold;
}

.c-first-name,
.c-last-name {
  min-width: 100px;
}
.c-email {
  min-width: 160px;
  word-wrap: break-word;
}
.c-attendee,
.c-ticket {
  min-width: 90px;
}

.c-attendee {
  text-decoration: underline;
  font-weight: 600;
  cursor: pointer;
}

.c-ticket {
  min-width: 160px;
}
.c-draw-status {
  min-width: 145px;
}
.c-time {
  min-width: 120px;
  flex-wrap: wrap;
}
.c-reject {
  min-width: 190px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  flex-wrap: wrap;
}

.data-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  /* padding: 0 30px; */
  flex-wrap: wrap;
}
.skip-container {
  display: flex;
}
.alert-reject {
  color: #e74c3c;
  background-color: rgba(208, 2, 27, 0.15);
}
.alert-skip {
  color: #0088ff;
  background-color: rgba(0, 136, 255, 0.15);
  min-width: 89px;
  height: 32px;
}

.alert-skipped {
  background-color: rgba(153, 153, 153, 0.15);
  color: #999999;
}

.skip {
  width: 26px;
  height: 32px;
  background-color: #0088ff;
  cursor: pointer;
  border: 1px solid #0088ff;
}
.skip img {
  width: 14px;
  height: 14px;
}
.empty_attendees {
  cursor: default;
  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/components/DrawTableRow.vue